module.exports = __webpack_public_path__ + "img/JOHN-icon.20688ac2.png";